import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import './FilterCategories.scss'
import { FiltersCategoryMenuItem } from '@/app/models/filters'

type FilterCategoriesProps = {
    showSavingFilter: boolean
    filterItems: FiltersCategoryMenuItem[]
}

const FilterCategories = (props: FilterCategoriesProps) => {
    const { filterItems, showSavingFilter } = props
    const intl = useIntl()

    return (
        <div className="smart-modals-filter-categories">
            <h1 className="title">
                {intl.formatMessage({
                    id: 'modals.filters.sidebar.title.filter_categories',
                    defaultMessage: 'Filter Categories',
                })}
            </h1>
            <div className={`smart-modals-filter-categories-menu`}>
                {filterItems.map((item, idx) => (
                    <FiltersCategoryItem key={idx} showSavingFilter={showSavingFilter} {...item} />
                ))}
            </div>
        </div>
    )
}

const FiltersCategoryItem = (props: FiltersCategoryMenuItem) => {
    const { onClick, label, showBadge, isActive, showSavingFilter } = props
    return (
        <div
            className={`smart-modals-filter-categories-menu-item ${
                isActive ? 'active' : showSavingFilter ? 'disabled' : ''
            }`}>
            <div onClick={showSavingFilter ? null : onClick}>
                <h4 className="menuitem-label">{label}</h4>
                {showBadge && (
                    <div className="smart-profile-badge">
                        <i className="cu cu-status-ok"></i>
                    </div>
                )}
                {!showSavingFilter && <i className="cu cu-caret-right"></i>}
            </div>
        </div>
    )
}
const mapStateToProps = (state: any) => ({})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(FilterCategories)
